<p-toast position="top-center"></p-toast>
<app-page-shell *ngIf="salesOrder">
    <app-page-detail-hero [auditStamp]="salesOrder"
        eyebrow="Sales Order"
        [title]="salesOrder.orderNumber || 'Sales Order'"
        [subtitle]="heroSubtitle()"
        icon="pi pi-file-edit">
        <div tags class="order-hero-tags">
            <div class="order-hero-status">
                <span>Commercial Status</span>
                <strong>{{ getStatusLabel(salesOrder.state) }}</strong>
            </div>
            <div class="order-hero-meta-tags">
                <p-tag [value]="getStatusLabel(getApprovalStatus())" [severity]="getStatusSeverity(getApprovalStatus())" [pTooltip]="getStatusTooltip(getApprovalStatus())"></p-tag>
                <p-tag *ngIf="!isServiceOnlyOrder()" [value]="getStatusLabel(getFulfillmentStatus())" [severity]="getStatusSeverity(getFulfillmentStatus())" [pTooltip]="getStatusTooltip(getFulfillmentStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getBillingStatus())" [severity]="getStatusSeverity(getBillingStatus())" [pTooltip]="getStatusTooltip(getBillingStatus())"></p-tag>
                <p-tag [value]="getStatusLabel(getHoldStatus())" [severity]="getStatusSeverity(getHoldStatus())" [pTooltip]="getStatusTooltip(getHoldStatus())"></p-tag>
                <p-tag *ngIf="hasLogisticsProject()" value="Project linked" severity="info"></p-tag>
            </div>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/order/sales-order"></p-button>
        </div>
    </app-page-detail-hero>

    <div class="order-detail-layout">
        <main class="order-detail-main">
            <app-page-metric-strip [metrics]="detailMetrics()"></app-page-metric-strip>

            <app-page-data-panel title="Sales Order Workspace" [subtitle]="getPartyName() + ' | ' + formatMoney(getTotalAmount())" [resultText]="getLineCount() + ' lines'">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)" styleClass="order-workspace-tabs">
            <p-tablist>
                <p-tab [value]="0"><span class="workspace-tab"><i class="pi pi-compass"></i><span>Overview</span></span></p-tab>
                <p-tab [value]="1"><span class="workspace-tab"><i class="pi pi-list-check"></i><span>Lines</span><span class="workspace-badge">{{ getLineCount() }}</span></span></p-tab>
                <p-tab [value]="2"><span class="workspace-tab"><i class="pi pi-sitemap"></i><span>Control</span></span></p-tab>
                <p-tab [value]="3"><span class="workspace-tab"><i class="pi pi-history"></i><span>Audit</span><span class="workspace-badge">{{ activity.length }}</span></span></p-tab>
                <p-tab [value]="4"><span class="workspace-tab"><i class="pi pi-paperclip"></i><span>Files</span><span class="workspace-badge">{{ salesOrder.attachments?.length || 0 }}</span></span></p-tab>
                <p-tab [value]="5"><span class="workspace-tab"><i class="pi pi-shield"></i><span>Workflow</span><span class="workspace-badge">{{ getBlockedActions().length }}</span></span></p-tab>
                <p-tab *ngIf="!isServiceOnlyOrder()" [value]="6"><span class="workspace-tab"><i class="pi pi-truck"></i><span>Fulfillment</span><span class="workspace-badge">{{ fulfillmentReleases?.releases?.length || 0 }}</span></span></p-tab>
                <p-tab [value]="7"><span class="workspace-tab"><i class="pi pi-receipt"></i><span>Invoice Readiness</span></span></p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <section class="order-workspace-section">
                    <div class="order-route-board">
                        <div class="order-route-endpoint">
                            <span class="endpoint-kicker">{{ crmActive() ? 'CRM Client' : 'Customer' }}</span>
                            <h3>{{ getPartyName() }}</h3>
                            <p>{{ salesOrder.shippingAddress || 'Delivery address pending' }}</p>
                        </div>
                        <div class="order-route-connector">
                            <span></span>
                            <i class="pi pi-file-edit"></i>
                            <span></span>
                        </div>
                        <div class="order-route-endpoint destination">
                            <span class="endpoint-kicker">Sales Order</span>
                            <h3>{{ salesOrder.orderNumber || '-' }}</h3>
                            <p *ngIf="salesOrder.externalReferenceNumber">Client Ref: <strong>{{ salesOrder.externalReferenceNumber }}</strong></p>
                            <p>{{ salesOrder.expectedDate ? (salesOrder.expectedDate | date:'mediumDate') : 'Expected date pending' }}</p>
                        </div>
                    </div>

                    <div class="order-summary-grid">
                        <div><span>Commercial</span><strong>{{ getStatusLabel(salesOrder.state) }}</strong></div>
                        <div><span>Approval</span><strong>{{ getStatusLabel(getApprovalStatus()) }}</strong></div>
                        <div *ngIf="!isServiceOnlyOrder()"><span>Fulfillment</span><strong>{{ getStatusLabel(getFulfillmentStatus()) }}</strong></div>
                        <div><span>Billing</span><strong>{{ getStatusLabel(getBillingStatus()) }}</strong></div>
                        <div><span>Hold</span><strong>{{ getStatusLabel(getHoldStatus()) }}</strong></div>
                        <div><span>Credit</span><strong>{{ getStatusLabel(getCreditStatus()) }}</strong></div>
                    </div>

                    <div class="workspace-grid">
                        <section class="workspace-section span-4">
                            <div class="section-heading">
                                <i class="pi pi-building"></i>
                                <div>
                                    <h3>Party &amp; Source</h3>
                                    <p>{{ salesOrder.orderNumber || '-' }}</p>
                                </div>
                            </div>
                            <div class="detail-grid party-source-grid">
                                <div><span>Customer</span><strong>{{ getPartyName() }}</strong></div>
                                <div><span>Client Reference</span><strong>{{ salesOrder.externalReferenceNumber || '-' }}</strong></div>
                                <div><span>{{ getCompanyOrCrmLabel() }}</span><strong>{{ getCompanyOrCrmValue() }}</strong></div>
                                @if (crmActive()) {
                                <div class="party-source-contact"><span>CRM Contact</span><strong>{{ selectedCrmContactLabel() }}</strong></div>
                                }
                                <div><span>Salesperson</span><strong>{{ salesOrder.salesperson?.name || '-' }}</strong></div>
                                <div><span>Logistics Project</span><strong>
                                    @if (salesOrder.logisticsProjectId) {
                                        <a [routerLink]="['/logistics-projects', salesOrder.logisticsProjectId]">{{ logisticsProjectName(salesOrder.logisticsProjectId) }}</a>
                                    } @else { - }
                                </strong></div>
                            </div>
                        </section>

                        <section class="workspace-section span-4">
                            <div class="section-heading">
                                <i class="pi pi-credit-card"></i>
                                <div>
                                    <h3>Commercial Terms</h3>
                                    <p>Dates, terms, and currency context</p>
                                </div>
                            </div>
                            <div class="detail-grid">
                                <div><span>Payment Term</span><strong>{{ salesOrder.paymentTerm?.name || '-' }}</strong></div>
                                <div><span>Order Date</span><strong>{{ salesOrder.orderDate ? (salesOrder.orderDate | date:'mediumDate') : '-' }}</strong></div>
                                <div><span>Expected Date</span><strong>{{ salesOrder.expectedDate ? (salesOrder.expectedDate | date:'mediumDate') : '-' }}</strong></div>
                                <div><span>Currency</span><strong>{{ currencyCode }}</strong></div>
                                <div><span>Exchange Rate</span><strong>{{ salesOrder.exchangeRate || 1 }}</strong></div>
                            </div>
                        </section>

                        <section class="workspace-section span-4">
                            <div class="section-heading">
                                <i class="pi pi-map-marker"></i>
                                <div>
                                    <h3>Addresses</h3>
                                    <p>Billing and delivery context</p>
                                </div>
                            </div>
                            <div class="address-stack">
                                <div>
                                    <span>Shipping</span>
                                    <strong>{{ salesOrder.shippingAddress || '-' }}</strong>
                                </div>
                                <div>
                                    <span>Billing</span>
                                    <strong>{{ salesOrder.billingAddress || '-' }}</strong>
                                </div>
                            </div>
                        </section>

                        <section class="workspace-section span-12" *ngIf="hasSourceQuotation()">
                            <div class="section-heading">
                                <i class="pi pi-file-plus"></i>
                                <div>
                                    <h3>Source Quotation</h3>
                                    <p>CRM quotation lineage and price basis</p>
                                </div>
                            </div>
                            <div class="detail-grid">
                                <div><span>Quotation</span><strong>{{ salesOrder.sourceQuotationNumber || ('#' + salesOrder.sourceQuotationId) }}</strong></div>
                                <div><span>Revision</span><strong>{{ salesOrder.sourceQuotationRevision || 1 }}</strong></div>
                                <div><span>Accepted / Approved</span><strong>{{ salesOrder.sourceQuotationAcceptedAt ? (salesOrder.sourceQuotationAcceptedAt | date:'medium') : '-' }}</strong><small>By {{ salesOrder.sourceQuotationAcceptedBy || '-' }}</small></div>
                                <div><span>Price Basis</span><strong>{{ salesOrder.priceBasis || 'CRM_QUOTATION' }}</strong></div>
                                <div><span>Contract</span><strong>{{ salesOrder.sourceContractId || '-' }}</strong></div>
                                <div><span>Rate Card</span><strong>{{ salesOrder.sourceRateCardId || '-' }}</strong></div>
                            </div>
                            <div class="mt-3">
                                <p-button label="View CRM Quotation" icon="pi pi-external-link" severity="secondary" [outlined]="true" (click)="viewSourceQuotation()"></p-button>
                            </div>
                        </section>

                        <section class="workspace-section span-12" *ngIf="hasHeaderFlexFields()">
                            <div class="section-heading">
                                <i class="pi pi-sliders-h"></i>
                                <div>
                                    <h3>Custom Fields</h3>
                                    <p>Header-specific order attributes</p>
                                </div>
                            </div>
                            <app-flex-field-view
                                [flexFields]="getHeaderFlexFields()"
                                containerClass="grid"
                                [isHeaderFields]="true"
                                itemClass="col-12 md:col-6 lg:col-4">
                            </app-flex-field-view>
                        </section>

                        <section class="workspace-section span-12">
                            <div class="section-heading">
                                <i class="pi pi-credit-card"></i>
                                <div>
                                    <h3>Credit Control</h3>
                                    <p>Customer exposure snapshot from receivables</p>
                                </div>
                            </div>
                            <div class="detail-grid">
                                <div><span>Status</span><strong><p-tag [value]="getStatusLabel(getCreditStatus())" [severity]="getStatusSeverity(getCreditStatus())"></p-tag></strong></div>
                                <div><span>Credit Limit</span><strong>{{ getCreditLimit() !== null && getCreditLimit() !== undefined ? (getCreditLimit() | currency:currencyCode:'symbol') : '-' }}</strong></div>
                                <div><span>Approved Credit Period</span><strong>{{ (salesOrder.creditPeriodDays ?? actionMetadata?.creditSnapshot?.creditPeriodDays) !== null && (salesOrder.creditPeriodDays ?? actionMetadata?.creditSnapshot?.creditPeriodDays) !== undefined ? (salesOrder.creditPeriodDays ?? actionMetadata?.creditSnapshot?.creditPeriodDays) + ' days' : '-' }}</strong></div>
                                <div><span>Order Payment Term</span><strong>{{ (salesOrder.orderPaymentTermDays ?? actionMetadata?.creditSnapshot?.orderPaymentTermDays) !== null && (salesOrder.orderPaymentTermDays ?? actionMetadata?.creditSnapshot?.orderPaymentTermDays) !== undefined ? (salesOrder.orderPaymentTermDays ?? actionMetadata?.creditSnapshot?.orderPaymentTermDays) + ' days' : '-' }}</strong></div>
                                <div><span>Check Mode</span><strong>{{ getCreditCheckModeLabel() }}</strong></div>
                                <div><span>Overdue Grace</span><strong>{{ salesOrder.overdueToleranceDays ?? actionMetadata?.creditSnapshot?.overdueToleranceDays ?? 0 }} days</strong></div>
                                <div><span>Open AR</span><strong>{{ (salesOrder.openARAmount || actionMetadata?.creditSnapshot?.openARAmount || 0) | currency:currencyCode:'symbol' }}</strong></div>
                                <div><span>Overdue AR</span><strong>{{ (salesOrder.overdueARAmount || actionMetadata?.creditSnapshot?.overdueARAmount || 0) | currency:currencyCode:'symbol' }}</strong></div>
                                <div><span>Available Credit</span><strong>{{ getAvailableCredit() !== null && getAvailableCredit() !== undefined ? (getAvailableCredit() | currency:currencyCode:'symbol') : '-' }}</strong></div>
                                <div><span>Override</span><strong>{{ salesOrder.creditOverrideId || actionMetadata?.creditSnapshot?.creditOverrideId || '-' }}</strong></div>
                            </div>
                            @if (getCreditBlockers().length || getCreditWarnings().length) {
                                <div class="control-alerts">
                                    @for (blocker of getCreditBlockers(); track blocker) {
                                        <div class="control-alert danger"><i class="pi pi-ban"></i><span>{{ blocker }}</span></div>
                                    }
                                    @for (warning of getCreditWarnings(); track warning) {
                                        <div class="control-alert warn"><i class="pi pi-exclamation-triangle"></i><span>{{ warning }}</span></div>
                                    }
                                </div>
                            }
                        </section>
                    </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="1">
                    <section class="order-workspace-section">
                    <div class="line-layout">
                        <div class="line-table">
                            <p-table [value]="getLines()" styleClass="p-datatable-sm order-lines-table" [tableStyle]="{ 'min-width': '68rem' }">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Line</th>
                                        <th>Product</th>
                                        <th class="text-right">Qty</th>
                                        <th class="text-right">Unit</th>
                                        <th class="text-right">Tax</th>
                                        <th class="text-right">Total</th>
                                        <th>Project</th>
                                        <th>Pricing</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-line>
                                    <tr>
                                        <td><strong>{{ line.lineNumber || '-' }}</strong></td>
                                        <td>
                                            <div class="line-title">{{ line.product?.name || line.description || 'Order line' }}</div>
                                            <div class="line-subtitle">{{ line.variant?.name || line.description || '-' }}</div>
                                            <app-flex-field-view *ngIf="getLineFlexFields(line).length"
                                                [flexFields]="getLineFlexFields(line)"
                                                [isHeaderFields]="false"
                                                containerClass="mt-2 text-sm"
                                                itemClass="text-sm">
                                            </app-flex-field-view>
                                        </td>
                                        <td class="text-right">{{ line.quantity | number:'1.0-2' }}</td>
                                        <td class="text-right">{{ line.unitPrice | currency:currencyCode:'symbol' : '1.4-4' }}</td>
                                        <td class="text-right">
                                            <strong>{{ line.totalTax | currency:currencyCode:'symbol' }}</strong>
                                            <small>{{ getLineTaxLabel(line) }}</small>
                                        </td>
                                        <td class="text-right"><strong>{{ getLineTotal(line) | currency:currencyCode:'symbol' }}</strong></td>
                                        <td>
                                            @if (line.logisticsProjectId || salesOrder.logisticsProjectId) {
                                                <a [routerLink]="['/logistics-projects', line.logisticsProjectId || salesOrder.logisticsProjectId]">{{ logisticsProjectName(line.logisticsProjectId || salesOrder.logisticsProjectId) }}</a>
                                            } @else { <span class="text-500">-</span> }
                                        </td>
                                        <td>
                                            <p-tag [value]="line.priceSource || 'MANUAL'" severity="secondary"></p-tag>
                                            <p-tag *ngIf="line.manualPriceOverride" value="Override" severity="warn" class="ml-2"></p-tag>
                                            <small *ngIf="line.sourceQuotationLineId">Quote line {{ line.sourceQuotationLineId }}</small>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr><td colspan="8" class="text-center p-4">No order lines found.</td></tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <aside class="totals-rail">
                            <div><span>Subtotal</span><strong>{{ getSubTotal() | currency:currencyCode:'symbol' }}</strong></div>
                            <div><span>Discount</span><strong>{{ getDiscountAmount() | currency:currencyCode:'symbol' }}</strong></div>
                            <div><span>Tax</span><strong>{{ getTotalTax() | currency:currencyCode:'symbol' }}</strong></div>
                            <div class="grand"><span>Total</span><strong>{{ getTotalAmount() | currency:currencyCode:'symbol' }}</strong></div>
                        </aside>
                    </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="2">
                    <section class="order-workspace-section">
                    <div class="status-board">
                        <section>
                            <i class="pi pi-check-circle"></i>
                            <span>Commercial</span>
                            <p-tag [value]="getStatusLabel(salesOrder.state)" [severity]="getStatusSeverity(salesOrder.state)"></p-tag>
                        </section>
                        <section>
                            <i class="pi pi-shield"></i>
                            <span>Approval</span>
                            <p-tag [value]="getStatusLabel(getApprovalStatus())" [severity]="getStatusSeverity(getApprovalStatus())"></p-tag>
                        </section>
                        <section *ngIf="!isServiceOnlyOrder()">
                            <i class="pi pi-truck"></i>
                            <span>Fulfillment</span>
                            <p-tag [value]="getStatusLabel(getFulfillmentStatus())" [severity]="getStatusSeverity(getFulfillmentStatus())"></p-tag>
                        </section>
                        <section>
                            <i class="pi pi-receipt"></i>
                            <span>Billing</span>
                            <p-tag [value]="getStatusLabel(getBillingStatus())" [severity]="getStatusSeverity(getBillingStatus())"></p-tag>
                        </section>
                        <section>
                            <i class="pi pi-lock-open"></i>
                            <span>Hold</span>
                            <p-tag [value]="getStatusLabel(getHoldStatus())" [severity]="getStatusSeverity(getHoldStatus())"></p-tag>
                        </section>
                    </div>
                    <div class="notes-panel">
                        <span>Notes</span>
                        @if (notesEditing) {
                            <p-editor
                                [(ngModel)]="notesDraft"
                                name="salesOrderNotesDraftControl"
                                styleClass="order-rich-editor"
                                [style]="{ height: '220px' }">
                            </p-editor>
                            <div class="notes-actions">
                                <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancelNotesEdit()" [disabled]="notesSaving"></p-button>
                                <p-button label="Save Notes" icon="pi pi-save" (click)="saveNotes()" [loading]="notesSaving"></p-button>
                            </div>
                        } @else if (salesOrder.notes) {
                            <div class="rich-html" [innerHTML]="salesOrder.notes"></div>
                            <div class="notes-actions">
                                <p-button label="Edit Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                            </div>
                        } @else {
                            <p>No notes for this order.</p>
                            <div class="notes-actions">
                                <p-button label="Add Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                            </div>
                        }
                    </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="3">
                    <section class="order-workspace-section">
                    <div class="audit-layout">
                        <section class="workspace-section">
                            <div class="section-heading">
                                <i class="pi pi-user-edit"></i>
                                <div>
                                    <h3>Order metadata</h3>
                                    <p>Confirmation and version</p>
                                </div>
                            </div>
                            <div class="detail-grid compact">
                                <div><span>Confirmed</span><strong>{{ salesOrder.confirmedAt ? (salesOrder.confirmedAt | date:'medium') : '-' }}</strong></div>
                                <div><span>Version</span><strong>{{ salesOrder.versionNumber ?? '-' }}</strong><small>Optimistic contract version</small></div>
                            </div>
                        </section>

                        <section class="workspace-section">
                            <div class="section-heading">
                                <i class="pi pi-history"></i>
                                <div>
                                    <h3>Activity</h3>
                                    <p>{{ activity.length }} events</p>
                                </div>
                            </div>
                            <div class="timeline" *ngIf="activity.length; else noSalesActivity">
                                <div class="timeline-item" *ngFor="let item of activity">
                                    <div class="timeline-dot"></div>
                                    <div>
                                        <strong>{{ item.eventType }}</strong>
                                        <p>{{ item.message || '-' }}</p>
                                        <small>{{ item.createdAt | date:'medium' }} | By {{ item.actor?.name || item.actorName || '-' }}</small>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noSalesActivity>
                                <div class="empty-state">No activity recorded.</div>
                            </ng-template>
                        </section>
                    </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="4">
                    <section class="order-workspace-section">
                    <div class="workspace-grid">
                        <section class="workspace-section span-7">
                            <div class="section-heading">
                                <i class="pi pi-paperclip"></i>
                                <div>
                                    <h3>Attachments</h3>
                                    <p>{{ salesOrder.attachments?.length || 0 }} files</p>
                                </div>
                            </div>
                            <div class="attachment-upload-bar">
                                <p-fileUpload
                                    name="salesOrderAttachment"
                                    mode="basic"
                                    [customUpload]="true"
                                    [disabled]="attachmentUploading"
                                    (onSelect)="onSalesOrderFileUpload($event)"
                                    chooseLabel="Upload File"
                                    chooseIcon="pi pi-cloud-upload">
                                </p-fileUpload>
                                @if (attachmentUploadProgress > 0) {
                                    <p-progressBar [value]="attachmentUploadProgress" [showValue]="true"></p-progressBar>
                                }
                            </div>
                            <div class="attachment-list" *ngIf="salesOrder.attachments?.length; else noAttachments">
                                <div class="attachment-row" *ngFor="let file of salesOrder.attachments">
                                    <i class="pi pi-file"></i>
                                    <div>
                                        <strong>{{ file.fileName }}</strong>
                                        <span>{{ formatFileSize(file.fileSize) }}</span>
                                    </div>
                                    <span class="flex align-items-center gap-1">
                                        <button pButton pRipple type="button" icon="pi pi-download" class="p-button-rounded p-button-text" aria-label="Download attachment" (click)="downloadAttachment(file)"></button>
                                        <button *ngIf="showEditAction() && file.attachmentId" pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" aria-label="Remove attachment" pTooltip="Remove attachment" [disabled]="attachmentDeleting" (click)="openAttachmentDelete(file)"></button>
                                    </span>
                                </div>
                            </div>
                            <ng-template #noAttachments>
                                <div class="empty-state">No attachments for this order.</div>
                            </ng-template>
                        </section>

                        <section class="workspace-section span-5">
                            <div class="section-heading">
                                <i class="pi pi-align-left"></i>
                                <div>
                                    <h3>Internal Notes</h3>
                                    <p>Commercial context</p>
                                </div>
                            </div>
                            <div class="notes-panel flat">
                                @if (notesEditing) {
                                    <p-editor
                                        [(ngModel)]="notesDraft"
                                        name="salesOrderNotesDraftFiles"
                                        styleClass="order-rich-editor"
                                        [style]="{ height: '220px' }">
                                    </p-editor>
                                    <div class="notes-actions">
                                        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancelNotesEdit()" [disabled]="notesSaving"></p-button>
                                        <p-button label="Save Notes" icon="pi pi-save" (click)="saveNotes()" [loading]="notesSaving"></p-button>
                                    </div>
                                } @else if (salesOrder.notes) {
                                    <div class="rich-html" [innerHTML]="salesOrder.notes"></div>
                                    <div class="notes-actions">
                                        <p-button label="Edit Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                                    </div>
                                } @else {
                                    <p>No notes for this order.</p>
                                    <div class="notes-actions">
                                        <p-button label="Add Notes" icon="pi pi-pencil" severity="secondary" [outlined]="true" (click)="startNotesEdit()"></p-button>
                                    </div>
                                }
                            </div>
                        </section>
                    </div>
                    </section>
                </p-tabpanel>

                <p-tabpanel [value]="5">
                    <section class="order-workspace-section">
                    <div class="workspace-grid">
                        <section class="workspace-section span-6 workflow-panel">
                            <div class="section-heading">
                                <i class="pi pi-shield"></i>
                                <div>
                                    <h3>Workflow State</h3>
                                    <p>Approval, hold, and lifecycle timestamps</p>
                                </div>
                            </div>
                            <div class="detail-grid compact workflow-state-grid">
                                <div><span>Submitted</span><strong>{{ salesOrder.submittedAt ? (salesOrder.submittedAt | date:'medium') : '-' }}</strong></div>
                                <div><span>Approved</span><strong>{{ salesOrder.approvedAt ? (salesOrder.approvedAt | date:'medium') : '-' }}</strong></div>
                                <div><span>Rejected</span><strong>{{ salesOrder.rejectedAt ? (salesOrder.rejectedAt | date:'medium') : '-' }}</strong><small>{{ salesOrder.rejectionReason || '-' }}</small></div>
                                <div><span>Held</span><strong>{{ salesOrder.heldAt ? (salesOrder.heldAt | date:'medium') : '-' }}</strong><small>{{ salesOrder.holdReason || '-' }}</small></div>
                                <div><span>Released</span><strong>{{ salesOrder.releasedAt ? (salesOrder.releasedAt | date:'medium') : '-' }}</strong></div>
                                <div><span>Closed</span><strong>{{ salesOrder.closedAt ? (salesOrder.closedAt | date:'medium') : '-' }}</strong></div>
                            </div>
                        </section>
                        <section class="workspace-section span-6 workflow-panel">
                            <div class="section-heading">
                                <i class="pi pi-ban"></i>
                                <div>
                                    <h3>Blocked Actions</h3>
                                    <p>{{ getBlockedActions().length }} unavailable actions</p>
                                </div>
                            </div>
                            <div class="timeline blocked-actions-list" *ngIf="getBlockedActions().length; else noBlockedActions">
                                <div class="timeline-item" *ngFor="let item of getBlockedActions()">
                                    <div class="timeline-dot"></div>
                                    <div>
                                        <strong>{{ actionLabel(item.action) }}</strong>
                                        <p>{{ item.reason }}</p>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noBlockedActions>
                                <div class="empty-state">No blocked actions.</div>
                            </ng-template>
                        </section>
                    </div>
                    </section>
                </p-tabpanel>

                <!-- Fulfillment Tab -->
                <p-tabpanel *ngIf="!isServiceOnlyOrder()" [value]="6">
                    <section class="order-workspace-section">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h3 style="margin:0"><i class="pi pi-truck mr-2"></i>Transport Releases</h3>
                        <div class="flex gap-2">
                            <p-button label="Create Delivery Release" icon="pi pi-plus" severity="success" [outlined]="true"
                                (click)="openDeliveryReleaseDialog()" [disabled]="!canCreateDeliveryRelease()"
                                [pTooltip]="canCreateDeliveryRelease() ? 'Create forward delivery release' : 'Order must be CONFIRMED/APPROVED and not ON HOLD'"></p-button>
                            <p-button label="Create Return Release" icon="pi pi-replay" severity="warn" [outlined]="true"
                                (click)="openReturnReleaseDialog()" [disabled]="!canCreateReturnRelease()"
                                [pTooltip]="canCreateReturnRelease() ? 'Create customer return release' : 'No delivered quantities to return'"></p-button>
                            <p-button label="Sync Fulfillment" icon="pi pi-refresh" severity="secondary" [outlined]="true"
                                (click)="syncFulfillment()" [loading]="syncLoading"></p-button>
                        </div>
                    </div>

                    <div *ngIf="fulfillmentReleases?.releases?.length; else noReleases">
                        <div *ngFor="let release of fulfillmentReleases?.releases" class="release-card mb-3">
                            <div class="flex justify-content-between align-items-center p-3 border-round border-1 surface-border">
                                <div>
                                    <div class="flex align-items-center gap-2">
                                        <strong>{{ release.releaseNumber }}</strong>
                                        <p-tag [value]="getReleaseDirectionLabel(release.fulfillmentDirection)" severity="info"></p-tag>
                                        <p-tag [value]="release.releaseRole || 'DIRECT'" severity="secondary"></p-tag>
                                        <p-tag [value]="release.releaseStatus" severity="secondary"></p-tag>
                                    </div>
                                    <small class="text-secondary">
                                        {{ release.originName || 'Origin' }} → {{ release.destinationName || 'Destination' }}
                                        <span *ngIf="release.pickupWindowStart">
                                            | Pickup: {{ release.pickupWindowStart | date:'shortDate' }}
                                        </span>
                                        <span *ngIf="release.deliveryWindowEnd">
                                            → {{ release.deliveryWindowEnd | date:'shortDate' }}
                                        </span>
                                        <span *ngIf="release.customerTrackingNumber">
                                            | Tracking: {{ release.customerTrackingNumber }}
                                        </span>
                                    </small>
                                </div>
                                <div class="flex gap-2 flex-wrap justify-content-end">
                                    <a [routerLink]="['/transport-planning/releases', release.releaseId]" pButton label="Release" icon="pi pi-external-link" size="small" severity="secondary" [outlined]="true"></a>
                                    <a *ngIf="release.crossDockOrchestrationId" [routerLink]="['/transport-planning/orchestrations', release.crossDockOrchestrationId]" pButton label="Orchestration" icon="pi pi-sitemap" size="small" severity="secondary" [outlined]="true"></a>
                                    <a *ngIf="release.linkedWarehouseTransferId" [routerLink]="['/warehousing/transfers/view', release.linkedWarehouseTransferId]" pButton label="Transfer" icon="pi pi-arrow-right-arrow-left" size="small" severity="secondary" [outlined]="true"></a>
                                    <a *ngIf="release.linkedWarehouseDispatchId" [routerLink]="['/warehousing/dispatch/view', release.linkedWarehouseDispatchId]" pButton label="Dispatch" icon="pi pi-box" size="small" severity="secondary" [outlined]="true"></a>
                                    <a *ngIf="release.plannedShipmentId" [routerLink]="['/shipment/view', release.plannedShipmentId]" pButton label="Shipment" icon="pi pi-external-link" size="small" severity="secondary" [outlined]="true"></a>
                                    <p-button *ngIf="isCancellableRelease(release)" label="Cancel" icon="pi pi-ban" size="small" severity="danger" [outlined]="true" [loading]="actionLoading" (click)="openCancelRelease(release.releaseId)"></p-button>
                                </div>
                            </div>
                            <div class="p-3" *ngIf="release.lines?.length">
                                <p-table [value]="release.lines" styleClass="p-datatable-sm" [tableStyle]="{'min-width':'40rem'}">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Item</th>
                                            <th>Qty</th>
                                            <th>UOM</th>
                                            <th>Action</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-line>
                                        <tr>
                                            <td>{{ line.itemName || line.itemCode || '-' }}</td>
                                            <td>{{ line.quantity }}</td>
                                            <td>{{ line.uom || '-' }}</td>
                                            <td><p-tag [value]="line.actionRequired || '-'" severity="secondary"></p-tag></td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                    <ng-template #noReleases>
                        <div class="empty-state p-4 text-center surface-100 border-round">
                            <i class="pi pi-truck text-4xl text-secondary mb-2"></i>
                            <p>No transport releases yet. Create a delivery release to start fulfillment.</p>
                        </div>
                    </ng-template>

                    <!-- Line Fulfillment Status -->
                    <div class="mt-4">
                        <h4><i class="pi pi-list-check mr-2"></i>Line Fulfillment Status</h4>
                        <p-button label="Retry FEFO Allocation" icon="pi pi-refresh" severity="secondary" [outlined]="true"
                            (click)="retryAllocation()" [loading]="actionLoading"></p-button>
                        <p-table [value]="getLines()" styleClass="p-datatable-sm" [tableStyle]="{'min-width':'50rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Line</th>
                                    <th>Product</th>
                                    <th>Ordered</th>
                                    <th>Allocation</th>
                                    <th>Shortage</th>
                                    <th>Released</th>
                                    <th>Delivered</th>
                                    <th>Returned</th>
                                    <th>Cancelled</th>
                                    <th>Remaining</th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-line let-i="rowIndex">
                                <tr>
                                    <td>{{ line.lineNumber || (i+1) }}</td>
                                    <td>{{ line.product?.productName || '-' }}</td>
                                    <td>{{ line.orderedQuantity || line.quantity }}</td>
                                    <td><p-tag [value]="allocationForLine(line.lineID)?.allocationStatus || line.allocationStatus || 'NOT REQUIRED'"
                                        [severity]="(allocationForLine(line.lineID)?.shortageBaseQuantity || 0) > 0 ? 'warn' : 'success'"></p-tag>
                                        <small class="block">{{ allocationForLine(line.lineID)?.allocatedBaseQuantity || line.allocatedBaseQuantity || 0 }} base</small></td>
                                    <td>{{ allocationForLine(line.lineID)?.shortageBaseQuantity || 0 }}</td>
                                    <td>{{ line.releasedQuantity || 0 }}</td>
                                    <td>{{ line.deliveredQuantity || 0 }}</td>
                                    <td>{{ line.returnedQuantity || 0 }}</td>
                                    <td>{{ line.cancelledQuantity || 0 }}</td>
                                    <td>{{ line.remainingQuantity || ((line.orderedQuantity || line.quantity) - (line.deliveredQuantity || 0) - (line.returnedQuantity || 0) - (line.cancelledQuantity || 0)) }}</td>
                                    <td>
                                        <p-button icon="pi pi-info-circle" size="small" severity="secondary" [text]="true" (click)="openLineSidePanel(line)" [pTooltip]="'View line details'"></p-button>
                                        <p-button *ngIf="canCorrectQuantity(line)" label="Correct Qty" icon="pi pi-pencil"
                                            size="small" severity="secondary" [outlined]="true" [loading]="correctionLoading"
                                            (click)="openQuantityCorrection(line)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    </section>
                </p-tabpanel>

                <!-- Invoice Readiness Tab -->
                <p-tabpanel [value]="7">
                    <section class="order-workspace-section">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h3 style="margin:0"><i class="pi pi-receipt mr-2"></i>Invoice Readiness</h3>
                        <div class="flex gap-2 align-items-center">
                            <span class="text-secondary mr-2">Policy:</span>
                            <p-tag [value]="invoiceReadiness?.invoicePolicy || 'ORDERED_QUANTITY'" severity="info"></p-tag>
                            <p-button [label]="invoiceReadiness?.receivableId ? 'Update Accounts' : 'Post To Accounts'" icon="pi pi-file-plus" severity="success"
                                (click)="postToAccounts()" [disabled]="!canPostToAccounts()" [loading]="draftLoading"
                                [pTooltip]="canPostToAccounts() ? 'Stage the sales order in To Invoice' : (invoiceReadiness?.blockingReasons?.[0] || 'No invoice-ready lines')"></p-button>
                        </div>
                    </div>

                    <div *ngIf="invoiceReadiness?.blockingReasons?.length" class="control-alerts mb-3">
                        <div class="control-alert warn" *ngFor="let reason of invoiceReadiness?.blockingReasons">
                            <i class="pi pi-exclamation-triangle"></i><span>{{ reason }}</span>
                        </div>
                    </div>
                    <div *ngIf="invoiceReadiness?.receivableId" class="mb-3 flex gap-3 flex-wrap">
                        <a [routerLink]="['/accounts/enterprise/receivables/to-be-invoiced/view', invoiceReadiness?.receivableId]">View receivable</a>
                        <a *ngIf="invoiceReadiness?.invoiceId" [routerLink]="['/accounts/enterprise/receivables/generated-invoices/view', invoiceReadiness?.invoiceId]">View invoice {{ invoiceReadiness?.invoiceNumber }}</a>
                    </div>

                    <div *ngIf="invoiceReadiness; else noInvoiceData">
                        <div class="mb-3 flex gap-3">
                            <div class="surface-100 p-3 border-round flex-1 text-center">
                                <small class="text-secondary">Ready to Invoice</small>
                                <strong class="text-xl block">{{ (invoiceReadiness.totalReadyToInvoiceAmount || 0) | currency:currencyCode:'symbol' }}</strong>
                            </div>
                            <div class="surface-100 p-3 border-round flex-1 text-center">
                                <small class="text-secondary">Already Invoiced</small>
                                <strong class="text-xl block">{{ (invoiceReadiness.totalInvoicedAmount || 0) | currency:currencyCode:'symbol' }}</strong>
                            </div>
                            <div class="surface-100 p-3 border-round flex-1 text-center">
                                <small class="text-secondary">Total Ordered</small>
                                <strong class="text-xl block">{{ (invoiceReadiness.totalOrderedAmount || 0) | currency:currencyCode:'symbol' }}</strong>
                            </div>
                        </div>

                        <p-table [value]="invoiceReadiness.lines" styleClass="p-datatable-sm" [tableStyle]="{'min-width':'50rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Line</th>
                                    <th>Product</th>
                                    <th>Ordered</th>
                                    <th>Delivered</th>
                                    <th>Returned</th>
                                    <th>Invoiced</th>
                                    <th>Remaining</th>
                                    <th>Ready Qty</th>
                                    <th>Tax</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-line>
                                <tr>
                                    <td>{{ line.lineNumber || '-' }}</td>
                                    <td>{{ line.productName || '-' }}</td>
                                    <td>{{ line.orderedQuantity }}</td>
                                    <td>{{ line.deliveredQuantity }}</td>
                                    <td>{{ line.returnedQuantity }}</td>
                                    <td>{{ line.invoicedQuantity }}</td>
                                    <td>{{ line.remainingQuantity }}</td>
                                    <td><strong>{{ line.invoiceReadyQuantity }}</strong></td>
                                    <td>{{ line.taxRate ? (line.taxRate + '%') : '-' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <ng-template #noInvoiceData>
                        <div class="empty-state p-4 text-center surface-100 border-round">
                            <i class="pi pi-receipt text-4xl text-secondary mb-2"></i>
                            <p>Invoice readiness data not loaded. Check order state and invoice policy.</p>
                        </div>
                    </ng-template>
                    </section>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
        </main>

        <aside class="business-action-pane" aria-label="Command Center">
            <header class="business-action-pane__header">
                <span class="business-action-pane__eyebrow">Command Center</span>
                <h2>Sales Order Actions</h2>
                <p>Manage order workflow, commercial updates, and documents.</p>
            </header>

            <div class="order-locked-notice" *ngIf="isInvoiceGenerated()">
                <i class="pi pi-lock"></i>
                <div>
                    <strong>Order Locked</strong>
                    <span>Customer invoice has been generated. No further modifications are allowed.</span>
                </div>
            </div>

            <section class="business-action-group business-action-group--primary" *ngIf="visibleHeaderLifecycleActions().length > 0">
                <div class="business-action-group__heading">
                    <i class="pi pi-bolt"></i>
                    <div>
                        <strong>Workflow Actions</strong>
                        <span>Lifecycle transitions and approvals</span>
                    </div>
                </div>
                <p-button *ngFor="let action of visibleHeaderLifecycleActions()"
                    [label]="action.label"
                    [icon]="action.icon"
                    [severity]="action.severity"
                    [outlined]="!!action.outlined"
                    (click)="openAction(action.code)"
                    [disabled]="actionLoading"
                    [pTooltip]="blockedReasonFor(action.code)">
                </p-button>
            </section>

            <section class="business-action-group">
                <div class="business-action-group__heading">
                    <i class="pi pi-sliders-h"></i>
                    <div>
                        <strong>Order Management</strong>
                        <span>Edit lines, header details, and project links</span>
                    </div>
                </div>
                <p-button *ngIf="showEditAction()"
                    label="Edit Order"
                    icon="pi pi-pencil"
                    severity="info"
                    (click)="editOrder()"
                    [disabled]="isEditLocked()"
                    [pTooltip]="editLockedTooltip()">
                </p-button>
                <p-button *ngIf="hasLogisticsProject()"
                    label="Linked Project"
                    icon="pi pi-briefcase"
                    severity="secondary"
                    [outlined]="true"
                    (click)="viewLogisticsProject()">
                </p-button>
                <p-button *ngIf="showCreateAction()"
                    label="New Sales Order"
                    icon="pi pi-plus"
                    severity="help"
                    [outlined]="true"
                    routerLink="/order/sales-order/add">
                </p-button>
            </section>

            <section class="business-action-group business-action-group--commercial">
                <div class="business-action-group__heading">
                    <i class="pi pi-file"></i>
                    <div>
                        <strong>Documents &amp; Accounting</strong>
                        <span>Export documents and accounting posting</span>
                    </div>
                </div>
                <p-button
                    label="Download PDF"
                    icon="pi pi-download"
                    severity="secondary"
                    [outlined]="true"
                    (click)="downloadPdf()">
                </p-button>
                <p-button
                    label="Post To Accounts"
                    icon="pi pi-file-plus"
                    severity="success"
                    [disabled]="!canPostToAccounts() || draftLoading"
                    (click)="postToAccounts()"
                    [pTooltip]="canPostToAccounts() ? 'Create a receivable in To Invoice' : 'No invoice-ready lines'">
                </p-button>
            </section>
        </aside>
    </div>
</app-page-shell>

<p-dialog [(visible)]="actionDialogVisible" [modal]="true" [style]="{width: '32rem'}" [header]="actionLabel(pendingAction)">
    <div class="flex flex-column gap-3">
        @if (blockedReasonFor(pendingAction)) {
            <div class="action-warning">
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ blockedReasonFor(pendingAction) }}</span>
            </div>
        }
        <label>
            Reason code
            <input pInputText [(ngModel)]="actionReasonCode" placeholder="Optional code" class="w-full">
        </label>
        <label>
            Reason
            <textarea pTextarea [(ngModel)]="actionReason" rows="4" class="w-full" [placeholder]="actionRequiresReason(pendingAction) ? 'Required for this action' : 'Optional comment'"></textarea>
        </label>
        <label *ngIf="actionRequiresCreditOverride(pendingAction)">
            Credit override ID
            <input pInputText type="number" [(ngModel)]="creditOverrideId" placeholder="Approved override reference">
        </label>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="actionDialogVisible=false" [disabled]="actionLoading"></p-button>
        <p-button label="Run action" icon="pi pi-check" [loading]="actionLoading" [disabled]="actionLoading" (click)="runAction()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Remove attachment" [(visible)]="attachmentDeleteDialogVisible" [modal]="true"
    [style]="{width: 'min(42rem, 96vw)'}" styleClass="order-attachment-delete-dialog"
    [draggable]="false" [closable]="!attachmentDeleting" (onHide)="attachmentToDelete=undefined">
    <div class="order-attachment-delete-body">
        <aside class="order-attachment-delete-summary">
            <i class="pi pi-trash"></i>
            <h3>Remove this file?</h3>
            <p>The file will be removed from this order and retained in storage for audit. Your reason will be recorded in the order activity.</p>
        </aside>
        <section class="order-attachment-delete-card">
            <strong>{{ attachmentToDelete?.fileName }}</strong>
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <textarea id="salesAttachmentDeleteReason" pTextarea [(ngModel)]="attachmentDeleteReason" rows="3" maxlength="500" class="w-full" [disabled]="attachmentDeleting"></textarea>
                    <label for="salesAttachmentDeleteReason">Reason for removal *</label>
                </p-iftalabel>
            </p-inputGroup>
            <small>Enter a reason so the removal can be reviewed later.</small>
            <small *ngIf="attachmentDeleteError" class="p-error">{{ attachmentDeleteError }}</small>
        </section>
    </div>
    <ng-template pTemplate="footer">
        <div class="order-attachment-delete-footer">
            <p-button label="Cancel" severity="secondary" [outlined]="true" [disabled]="attachmentDeleting" (click)="attachmentDeleteDialogVisible=false"></p-button>
            <p-button label="Remove attachment" icon="pi pi-trash" severity="danger" [loading]="attachmentDeleting"
                [disabled]="!attachmentDeleteReason.trim() || attachmentDeleting" (click)="deleteAttachment()"></p-button>
        </div>
    </ng-template>
</p-dialog>
<p-dialog header="Correct Sales Order Quantity" [(visible)]="correctionVisible" [modal]="true"
    [style]="{width: 'min(56rem, 96vw)'}" [breakpoints]="{'640px': '96vw'}" [draggable]="false">
    <div *ngIf="correctionPreview" class="flex flex-column gap-3">
        <p>Confirming cancels every linked release family and warehouse document, updates the order quantity,
            then creates replacement releases. If any step fails, nothing is saved.</p>
        <div *ngFor="let impact of correctionPreview.releaseImpact" class="surface-50 border-round p-2">
            <strong>Release #{{ impact.rootReleaseId }}</strong>
            <small class="block">{{ impact.releaseIds.length }} release leg(s) · {{ impact.transferIds.length }} transfer(s)
                · {{ impact.dispatchIds.length }} dispatch(es)</small>
        </div>
        <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftalabel>
                <p-inputNumber [ngModel]="correctionQuantity" (ngModelChange)="onCorrectionQuantityChange($event)"
                    [min]="0.0001" [maxFractionDigits]="4" [useGrouping]="false" styleClass="w-full"></p-inputNumber>
                <label>New ordered quantity *</label>
            </p-iftalabel>
        </p-inputGroup>
        <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
            <p-iftalabel>
                <textarea pTextarea [(ngModel)]="correctionReason" maxlength="500" rows="2" class="w-full"></textarea>
                <label>Reason for cancellation *</label>
            </p-iftalabel>
        </p-inputGroup>
        <div *ngFor="let group of correctionGroups" class="surface-50 border-round p-3 flex flex-column gap-2">
            <strong>Replace release #{{ group.rootReleaseId }}</strong>
            <small>Review pickup, dropoff, route and timing. Other order lines retain their released quantities.</small>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                        <p-iftalabel><p-inputNumber [(ngModel)]="group.replacement.originLocationId"
                            [useGrouping]="false" styleClass="w-full"></p-inputNumber><label>Pickup location ID</label></p-iftalabel>
                    </p-inputGroup>
                      <small>{{ group.originName || 'Pickup location unavailable' }}</small>
                </div>
                <div class="col-12 md:col-6">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                        <p-iftalabel><p-inputNumber [(ngModel)]="group.replacement.destinationLocationId"
                            [useGrouping]="false" styleClass="w-full"></p-inputNumber><label>Dropoff location ID</label></p-iftalabel>
                    </p-inputGroup>
                      <small>{{ group.destinationName || 'Dropoff location unavailable' }}</small>
                </div>
                <div class="col-12 md:col-6">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                        <p-iftalabel><p-datepicker [(ngModel)]="group.replacement.pickupWindowStart"
                            [showTime]="true" appendTo="body" styleClass="w-full"></p-datepicker><label>Pickup from</label></p-iftalabel>
                    </p-inputGroup>
                </div>
                <div class="col-12 md:col-6">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                        <p-iftalabel><p-datepicker [(ngModel)]="group.replacement.deliveryWindowEnd"
                            [showTime]="true" appendTo="body" styleClass="w-full"></p-datepicker><label>Delivery by</label></p-iftalabel>
                    </p-inputGroup>
                </div>
                <div class="col-12 md:col-6">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                        <p-iftalabel><p-inputNumber [(ngModel)]="group.replacement.routeTemplateId"
                            [useGrouping]="false" styleClass="w-full"></p-inputNumber><label>Route template ID</label></p-iftalabel>
                    </p-inputGroup>
                </div>
            </div>
            <div *ngFor="let line of group.replacement.lines" class="flex align-items-center gap-2 flex-wrap">
                <span>Line #{{ line.salesOrderLineId }}</span>
                <p-inputNumber [(ngModel)]="line.quantity" [min]="0" [maxFractionDigits]="4"
                    [useGrouping]="false" [disabled]="line.salesOrderLineId !== correctionPreview.lineId"></p-inputNumber>
                <small *ngIf="line.salesOrderLineId !== correctionPreview.lineId">Preserved from shared release</small>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Back" severity="secondary" [outlined]="true" (click)="correctionVisible=false"></p-button>
        <p-button label="Cancel and Replace" icon="pi pi-check" [loading]="correctionLoading"
            (click)="submitQuantityCorrection()"></p-button>
    </ng-template>
</p-dialog>
<p-dialog header="Cancel Order Release" [(visible)]="cancelReleaseVisible" [modal]="true"
    [style]="{width: 'min(32rem, 96vw)'}" [draggable]="false">
    <p>Release #{{ cancelReleaseRootId }} and its linked child legs and warehouse work will be cancelled.</p>
    <p-inputGroup><p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
        <p-iftalabel><textarea pTextarea [(ngModel)]="cancelReleaseReason" maxlength="500" rows="3"
            class="w-full"></textarea><label>Cancellation reason *</label></p-iftalabel></p-inputGroup>
    <ng-template pTemplate="footer">
        <p-button label="Back" severity="secondary" [outlined]="true" (click)="cancelReleaseVisible=false"></p-button>
        <p-button label="Cancel Release" severity="danger" [loading]="actionLoading"
            [disabled]="!cancelReleaseReason.trim()" (click)="cancelDeliveryRelease()"></p-button>
    </ng-template>
</p-dialog>

<!-- Delivery Release Dialog -->
<p-dialog [(visible)]="deliveryReleaseDialogVisible" [modal]="true" [style]="{width: '40rem'}" header="Create Delivery Release">
    <div class="flex flex-column gap-3">
        <div *ngIf="fulfillmentReadiness?.blockingReasons?.length" class="control-alerts mb-2">
            <div class="control-alert warn" *ngFor="let reason of fulfillmentReadiness?.blockingReasons">
                <i class="pi pi-exclamation-triangle"></i><span>{{ reason }}</span>
            </div>
        </div>
        <p *ngIf="fulfillmentReadiness?.ready" class="text-secondary">
            {{ deliveryReleaseLines.length }} lines available. The backend will split warehouse groups and create direct or cross-dock execution automatically.
        </p>
        <div *ngIf="!fulfillmentReadiness?.ready && !fulfillmentReadiness?.blockingReasons?.length" class="text-secondary">
            Loading readiness...
        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="deliveryDestination">Ship-to location</label>
                <p-select inputId="deliveryDestination" appLazyLocationPicker optionLabel="name" optionValue="id"
                    [(ngModel)]="deliveryDestinationLocationId" [filter]="true" styleClass="w-full" appendTo="body"></p-select>
            </div>
            <div class="field col-12 md:col-6">
                <label for="deliveryWindowStart">Delivery window start</label>
                <p-datePicker inputId="deliveryWindowStart" [(ngModel)]="deliveryWindowStart" [showTime]="true" styleClass="w-full" appendTo="body"></p-datePicker>
            </div>
            <div class="field col-12 md:col-6">
                <label for="deliveryWindowEnd">Delivery window end</label>
                <p-datePicker inputId="deliveryWindowEnd" [(ngModel)]="deliveryWindowEnd" [showTime]="true" styleClass="w-full" appendTo="body"></p-datePicker>
            </div>
        </div>
        <div *ngIf="fulfillmentReadiness?.warehouseGroups?.length">
            <h4 class="mb-2">Warehouse handoff</h4>
            <div class="flex flex-wrap gap-2">
                <p-tag *ngFor="let group of fulfillmentReadiness?.warehouseGroups"
                    [value]="(group.sourceWarehouseName || ('Warehouse ' + group.sourceWarehouseId)) + ' · ' + (group.routeMode || 'Needs setup')"
                    [severity]="group.blockingReason ? 'danger' : (group.routeMode === 'CROSS_DOCK' ? 'warn' : 'success')"
                    [pTooltip]="group.blockingReason || group.stockOwnerType || ''"></p-tag>
            </div>
        </div>
        <p-table *ngIf="deliveryReleaseLines.length" [value]="deliveryReleaseLines" styleClass="p-datatable-sm">
            <ng-template pTemplate="header"><tr><th>Line</th><th>Product</th><th>Warehouse</th><th>Release qty</th></tr></ng-template>
            <ng-template pTemplate="body" let-line>
                <tr>
                    <td>{{ line.lineNumber || line.lineId }}</td>
                    <td>{{ line.productName || '-' }}</td>
                    <td>{{ line.warehouseId || '-' }}</td>
                    <td><p-inputNumber [(ngModel)]="line.quantity" [min]="0" [max]="line.maximum" [maxFractionDigits]="4" styleClass="w-full"></p-inputNumber></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="deliveryReleaseDialogVisible=false"></p-button>
        <p-button label="Create Delivery Release" icon="pi pi-check" severity="success"
            [loading]="actionLoading" (click)="createDeliveryRelease()"
            [disabled]="!fulfillmentReadiness?.ready || !deliveryDestinationLocationId || !deliveryReleaseLines.length"></p-button>
    </ng-template>
</p-dialog>

<!-- Return Release Dialog -->
<p-dialog [(visible)]="returnReleaseDialogVisible" [modal]="true" [style]="{width: '40rem'}" header="Create Return Release">
    <div class="flex flex-column gap-3">
        <p class="text-secondary">
            Deliverable lines with quantity delivered and not yet returned:
        </p>
        <p-table [value]="returnableLines()" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th>Line</th>
                    <th>Product</th>
                    <th>Delivered</th>
                    <th>Returnable</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
                <tr>
                    <td>{{ line.lineNumber }}</td>
                    <td>{{ line.product?.name || '-' }}</td>
                    <td>{{ line.deliveredQuantity || 0 }}</td>
                    <td>{{ (line.deliveredQuantity || 0) - (line.returnedQuantity || 0) }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="returnReleaseDialogVisible=false"></p-button>
        <p-button label="Create Return Release" icon="pi pi-check" severity="warn"
            [loading]="actionLoading" (click)="createReturnRelease()"
            [disabled]="!hasReturnableLines()"></p-button>
    </ng-template>
</p-dialog>

<!-- Line Side Panel -->
<p-dialog [(visible)]="lineSidePanelVisible" [modal]="false" [style]="{width: '28rem'}" [draggable]="false"
    header="Line Detail" [position]="'right'" styleClass="line-side-panel">
    <div *ngIf="selectedLine" class="flex flex-column gap-3">
        <div>
            <strong>{{ selectedLine.product?.name || 'Line ' + (selectedLine.lineNumber || '') }}</strong>
            <p class="text-secondary">{{ selectedLine.description || 'No description' }}</p>
        </div>
        <div class="detail-grid compact">
            <div><span>Line Number</span><strong>{{ selectedLine.lineNumber || '-' }}</strong></div>
            <div><span>Variant</span><strong>{{ selectedLine.variant?.name || '-' }}</strong></div>
        </div>
        <h4 class="mt-2">Fulfillment</h4>
        <div class="detail-grid compact">
            <div><span>Ordered</span><strong>{{ selectedLine.orderedQuantity || selectedLine.quantity }}</strong></div>
            <div><span>Allocated</span><strong>{{ selectedLine.allocatedQuantity || 0 }}</strong></div>
            <div><span>Released</span><strong>{{ selectedLine.releasedQuantity || 0 }}</strong></div>
            <div><span>Fulfilled</span><strong>{{ selectedLine.fulfilledQuantity || 0 }}</strong></div>
            <div><span>Delivered</span><strong>{{ selectedLine.deliveredQuantity || 0 }}</strong></div>
            <div><span>Returned</span><strong>{{ selectedLine.returnedQuantity || 0 }}</strong></div>
            <div><span>Cancelled</span><strong>{{ selectedLine.cancelledQuantity || 0 }}</strong></div>
            <div><span>Remaining</span><strong>{{ selectedLine.remainingQuantity || ((selectedLine.orderedQuantity || selectedLine.quantity) - (selectedLine.deliveredQuantity || 0) - (selectedLine.returnedQuantity || 0) - (selectedLine.cancelledQuantity || 0)) }}</strong></div>
        </div>
        <h4 class="mt-2">Billing</h4>
        <div class="detail-grid compact">
            <div><span>Invoiced</span><strong>{{ selectedLine.invoicedQuantity || 0 }}</strong></div>
            <div><span>Invoice Ready</span><strong>{{ (selectedLine.deliveredQuantity || 0) - (selectedLine.returnedQuantity || 0) - (selectedLine.invoicedQuantity || 0) }}</strong></div>
        </div>
        <h4 class="mt-2">Pricing &amp; Tax</h4>
        <div class="detail-grid compact">
            <div><span>Unit Price</span><strong>{{ (selectedLine.unitPrice || 0) | currency:currencyCode:'symbol' : '1.4-4' }}</strong></div>
            <div><span>Tax Code</span><strong>{{ selectedLine.taxCode || '-' }}</strong></div>
            <div><span>Tax Rate</span><strong>{{ selectedLine.taxRate ? (selectedLine.taxRate + '%') : '-' }}</strong></div>
            <div><span>Total Tax</span><strong>{{ (selectedLine.totalTax || 0) | currency:currencyCode:'symbol' }}</strong></div>
            <div><span>Line Total</span><strong>{{ (selectedLine.totalLineAmount || 0) | currency:currencyCode:'symbol' }}</strong></div>
        </div>
        <div *ngIf="selectedLine.outboundReleaseId" class="mt-2">
            <p-tag value="Outbound Release #{{ selectedLine.outboundReleaseId }}" severity="info"></p-tag>
        </div>
        <div *ngIf="selectedLine.returnReleaseId" class="mt-2">
            <p-tag value="Return Release #{{ selectedLine.returnReleaseId }}" severity="warn"></p-tag>
        </div>
        <div *ngIf="selectedLine.sourceQuotationLineId" class="mt-2">
            <small class="text-secondary">Source: CRM Quotation Line #{{ selectedLine.sourceQuotationLineId }}</small>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="lineSidePanelVisible=false"></p-button>
    </ng-template>
</p-dialog>
